import { useState } from 'react';
import { Box, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { ConfirmationDialog } from '@shared/components';
import { clearAllAuthData } from '@core/index';
import { useNavigate } from 'react-router-dom';

export const Logout = () => {
  const navigate = useNavigate();

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleLogoutClick = async () => {
    clearAllAuthData();
    setLogoutDialogOpen(false);
    navigate('/login', { replace: true });
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <ListItemButton
          onClick={() => setLogoutDialogOpen(true)}
          sx={{
            minHeight: 48,
            px: 2.5,
            '& .MuiListItemIcon-root': {
              color: 'text.primary',
            },
            '& .MuiListItemText-primary': {
              color: 'text.primary',
              fontSize: '0.875rem',
              letterSpacing: '0.5px',
              fontWeight: 600,
            },
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.12)',
              '& .MuiListItemIcon-root': {
                color: 'primary.main',
              },
              '& .MuiListItemText-primary': {
                color: 'primary.main',
              },
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: 2,
              justifyContent: 'center',
            }}
          >
            <PowerSettingsNewIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </Box>

      <ConfirmationDialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        onConfirm={handleLogoutClick}
        title="Logout"
        message="Are you sure you want to logout?"
        confirmText="Logout"
        cancelText="Cancel"
        variant="warning"
        confirmColor="primary"
      />
    </>
  );
};

export default Logout;
